<template>
  <div>
    <div style="display: flex;flex-direction: column;width: 100%;" v-if="orderDetail.servCataId!='3010130'">
      <!-- 基本信息 -->
      <div class="order-input-wrap">
        <base-tag label="基本信息"></base-tag>
        <y-tooth :singleDataList="orderDetail.posSingleList" :bridgeDataList="orderDetail.posBridgeList" :isShow="true"
          :withServCataId="orderDetail.withServCataId" v-if="common.serv.get(orderDetail.servCataId).isTooth === '1'"
          @toothNum="toothNum"/>

        <div class="radio-wrap" v-if="bridgeFlag">
          <el-radio v-model="isBridge" :label="false" disabled>单冠</el-radio>
          <el-radio v-model="isBridge" :label="true" disabled>连桥</el-radio>
        </div>

        <!-- 联系人姓名 -->
        <div class="input-form-wrap-row">
          <div class="input-label">
            <span>下单名称：</span>
          </div>
          <div class="input-value">
            {{orderDetail.demContact}}
          </div>
        </div>

        <!-- 联系方式 -->
        <div class="input-form-wrap-row">
          <div class="input-label">
            <span>联系方式：</span>
          </div>
          <div class="input-value">
            {{orderDetail.demPhone}}
          </div>
        </div>

        <!-- 患者姓名 -->
        <div class="input-form-wrap-row">
          <div class="input-label">
            <span>患者姓名：</span>
          </div>
          <div class="input-value">
            {{orderDetail.demPatient}}
          </div>
        </div>

      <!-- 患者性别 -->
      <div class="input-form-wrap-row">
        <div class="input-label">
          <span>患者性别：</span>
        </div>
        <div class="input-value">
          {{orderDetail.demSex == '00' ? '男':'女'}}
        </div>
      </div>

      </div>

      <!-- 订单信息 -->
      <div class="order-input-wrap">

        <base-tag label="设计费详情"></base-tag>
        <!-- 数量 -->
        <div class="input-form-wrap-row">
          <div class="input-label">
            <span>数量：</span>
          </div>
          <div class="input-value">
            {{orderCount}}
          </div>
        </div>
        <!-- 单价 -->
        <div class="input-form-wrap-row">
          <div class="input-label">
            <span>单价：</span>
          </div>
          <div class="input-value">
            {{parseMoney(orderDetail.orderPrice) }} 元
          </div>
        </div>
        <!-- 数量 -->
        <div class="input-form-wrap-row" v-if="fund>0&&((orderDetail.servCataId == '1010120'||
        orderDetail.servCataId == '1010210'||orderDetail.servCataId == '1010220')&&orderDetail.withServCataId!=='')">
          <div class="input-label">
            <span>基台数量：</span>
          </div>
          <div class="input-value">
            {{fund}}
          </div>
        </div>
        <!-- 单价 -->
        <div class="input-form-wrap-row" v-if="fund>0&&((orderDetail.servCataId == '1010120'||
        orderDetail.servCataId == '1010210'||orderDetail.servCataId == '1010220')&&orderDetail.withServCataId!=='')">
          <div class="input-label">
            <span>基台单价：</span>
          </div>
          <div class="input-value">
            {{parseMoney(basePrice) }} 元
          </div>
        </div>
        <!-- 数量 -->
        <div class="input-form-wrap-row" v-if="quantity>0&&orderDetail.servCataId !== '1010410'">
          <div class="input-label">
            <span>上部冠数量：</span>
          </div>
          <div class="input-value">
            {{quantity}}
          </div>
        </div>
        <!-- 单价 -->
        <div class="input-form-wrap-row" v-if="quantity>0&&orderDetail.servCataId !== '1010410'">
          <div class="input-label">
            <span>上部冠单价：</span>
          </div>
          <div class="input-value">
            {{parseMoney(extraUnitPrice) }} 元
          </div>
        </div>
      <!-- 加急费 -->
      <div class="input-form-wrap-row" v-if="orderDetail.orderRushFee != 0">
        <div class="input-label">
          <span>加急费：</span>
        </div>
        <div class="input-value">
          {{parseMoney(orderDetail.orderRushFee) }}
        </div>
      </div>
      <!-- 模型编辑费 -->
      <div class="input-form-wrap-row" v-if="orderDetail.isEditScanModel=='1'">
        <div class="input-label">
          <span>口扫模型编辑：</span>
        </div>
        <div class="input-value">
          {{parseMoney(common.serv.get(orderDetail.servCataId).editScanModelBprice)}} 元
        </div>
      </div>
      <!-- 总价 -->
      <div class="input-form-wrap-row">
        <div class="input-label">
          <span>总价：</span>
        </div>
        <div class="input-value">
          {{parseMoney(orderDetail.orderAmount) }} 元
        </div>
      </div>

      </div>
      <!-- 设计信息 -->
      <div class="order-input-wrap" v-if="digitalize">

        <base-tag label="设计信息"></base-tag>

        <!-- 设计师级别 -->
      <div class="input-form-wrap-row" v-if="orderDetail.desLevel != '99'&&orderDetail.servCataId!=='1010410'&&orderDetail.servCataId!=='1010510'">
        <div class="input-label">
            <span>设计师级别：</span>
          </div>
          <div class="input-value" v-if="orderDetail.desLevel == '99'">
            <span>认证级</span>
          </div>
          <div class="input-value" v-else>
            <dict-tag dict="biz_des_level" :value="orderDetail.desLevel" />
          </div>
        </div>

        <div class="input-form-wrap-row"
        v-if="(quantity>0&&orderDetail.servCataId !== '1010410')||orderDetail.servCataId=='1010120'">
          <div class="input-label">
            <span>修复体材质：</span>
          </div>
          <div class="input-value">
            {{orderDetail.repairMaterial == '00'? '氧化锆':(orderDetail.repairMaterial == '01'?'玻璃陶瓷':'树脂')}}
          </div>
        </div>

        <!-- 冠部是否开孔 -->
        <!-- <div class="input-form-wrap-row" v-if="common.serv.get(orderDetail.servCataId).isHole === '1'"> -->
        <div class="input-form-wrap-row"
        v-if="(quantity>0&&orderDetail.servCataId !== '1010410')||orderDetail.servCataId=='1010120'">
          <div class="input-label">
            <span>冠部是否开孔：</span>
          </div>
          <div class="input-value">
            <dict-tag dict="biz_yes_no" :value="orderDetail.posHole" />
          </div>
        </div>
        <div class="input-form-wrap-row"
        v-if="orderDetail.posHole=='1'">
          <div class="input-label">
            <span>冠部是否开孔：</span>
          </div>
          <div class="input-value" :style="orderDetail.holeDiameter!=2.5?'color:#2979ff;':''">
            {{ orderDetail.holeDiameter }}mm
          </div>
        </div>

        <!-- 舌侧金属边 -->
  <!--      <div class="input-form-wrap-row" v-if="common.serv.get(orderDetail.servCataId).isCollar === '1'">
          <div class="input-label">
            <span>舌侧金属边：</span>
          </div>
          <div class="input-value">
            <dict-tag dict="biz_yes_no" :value="orderDetail.collar" />
          </div>
        </div> -->


        <!-- 最小厚度 -->
  <!--     <div class="input-form-wrap-row" v-if="common.serv.get(orderDetail.servCataId).isMinThick === '1'">
          <div class="input-label">
            <span>最小厚度：</span>
          </div>
          <div class="input-value">
            <span>{{orderDetail.minThick}} mm</span>
          </div>
        </div> -->

        <!-- 膜片厚度 -->
  <!--      <div class="input-form-wrap-row" v-if="common.serv.get(orderDetail.servCataId).isDiapThick === '1'">
          <div class="input-label">
            <span>膜片厚度：</span>
          </div>
          <div class="input-value">
            <span>{{orderDetail.diapThick}} mm</span>
          </div>
        </div> -->

        <!-- 共同就位道 -->
        <!-- <div class="input-form-wrap-row" v-if="common.serv.get(orderDetail.servCataId).isAbutPath === '1'">
          <div class="input-label">
            <span>共同就位道 ：</span>
          </div>
          <div class="input-value">
            <dict-tag dict="biz_need_yes_no" :value="orderDetail.abutPath" />
          </div>
        </div> -->
        <div class="input-form-wrap-row" v-if="['2010120','2010210','2010220','2010320','2010420','1010120'].includes(orderDetail.servCataId)&&['0',''].includes(orderDetail.withServCataId)">
          <div class="input-label">
            <span>设计软件：</span>
          </div>
          <div class="input-value">
            <span>{{orderDetail.designSoftware=='00'?'通用':'exocad'}}</span>
          </div>
        </div>
        <div class="input-form-wrap-row"
        v-if="(fixed||orderDetail.servCataId=='1010120'||orderDetail.withServCataId.includes('1010120')) && CAMName">
          <div class="input-label">
            <span>CAM制造设备：</span>
          </div>
          <div class="input-value">
            <span>{{CAMName}}</span>
          </div>
        </div>

      </div>

      <!-- 植体系统-->
      <div class="order-input-wrap" v-if="common.serv.get(orderDetail.servCataId).isImpSystem == '1'">

        <base-tag label="种植体信息"></base-tag>
        <!-- <div :class="orderDetail.impSystem.length <= 9 ? 'input-form-wrap-two':(orderDetail.impSystem.length >12 ? 'input-form-wrap-system':'input-form-wrap-three')"> -->
        <div class="input-form-wrap-two ">
          <div class="input-label">
            <span>植体系统 ：</span>
          </div>
          <div class="input-value">
            {{orderDetail.impSystem}}
          </div>
        </div>

        <!-- <div :class="orderDetail.impModel.length > 15 ? 'input-form-wrap-system':'input-form-wrap-two'"> -->
        <div class="input-form-wrap-two">
          <div class="input-label">
            <span>植体型号 ：</span>
          </div>
          <div class="input-value" v-if="orderDetail.impSystem != '99'">
            {{orderDetail.impModel}}
          </div>
          <div class="input-value" v-else>
            <span>{{orderDetail.impExtra}}</span>
          </div>
        </div>
        <div class="input-form-wrap-row"
        v-if="(orderDetail.servCataId == '1010210'||
              orderDetail.servCataId == '1010220' ||
              orderDetail.servCataId == '1010310' ||
              orderDetail.servCataId == '1010320' ||
              orderDetail.servCataId == '1010410' ||
              orderDetail.servCataId == '1010510')">
          <div class="input-label">
            <span>扫描杆：</span>
          </div>
          <div class="input-value">
            {{orderDetail.scanningRod == '01' ? '口内扫描杆':'口外扫描杆'}}
          </div>
        </div>

      <div class="input-form-wrap-row"
        v-if="orderDetail.scanningRodSupplier">
          <div class="input-label">
            <span>扫描杆供应商：</span>
          </div>
          <div class="input-value">
            {{orderDetail.scanningRodSupplier}}
          </div>
        </div>
        <!-- 杆卡类型 -->
        <div class="input-form-wrap-row" v-if="common.serv.get(orderDetail.servCataId).isCollar === '1'"
        style="margin-top:10px;">
          <div class="input-label">
            <span>杆卡类型：</span>
          </div>
          <div class="input-value">
            {{orderDetail.collar}}
          </div>
        </div>

        <!-- 精密附件及型号 -->
        <div :class="orderDetail.subgingival.length>7?'input-form-wrap-fore':'input-form-wrap-row'" v-if="orderDetail.servCataId=='1010510'"
          style="margin-top:10px;">
          <div class="input-label" style="width: 112px;">
            <span>精密附件及型号：</span>
          </div>
          <div class="input-value">
            <span>{{orderDetail.subgingival}}</span>
          </div>
        </div>

        <!-- 桥架上部修复工艺 -->
        <div class="input-form-wrap-row" v-if="common.serv.get(orderDetail.servCataId).isBriCraft === '1'" style="margin:10px 0 0 5px;width: 24.5%;">
          <div class="input-label-bridge">
            <span>桥架上部修复工艺 ：</span>
          </div>
          <div class="input-value" style="padding: 2px 5px;">
            <dict-tag dict="biz_bridge_craft" :value="orderDetail.briCraft" />
          </div>
        </div>

      <!-- 导板类型 -->
      <div class="input-form-wrap-row" v-if="common.serv.get(orderDetail.servCataId).isPlate === '1'">
        <div class="input-label">
          <span>导板类型 ：</span>
        </div>
        <div class="input-value">
          <dict-tag dict="biz_plate_type" :value="orderDetail.plateType" />
        </div>
      </div>

      <div class="input-form-wrap-row"
      v-if="(orderDetail.servCataId=='1010698'||orderDetail.servCataId=='1010699'||orderDetail.servCataId=='1010700')&& CAMName">
        <div class="input-label">
          <span>CAM制造设备：</span>
        </div>
        <div class="input-value">
          <span>{{CAMName}}</span>
        </div>
      </div>

      </div>

      <!-- 参数信息 -->
      <div class="order-input-wrap" v-if="common.serv.get(orderDetail.servCataId).isParam === '1'">
        <base-tag class="param-info" label="参数信息"></base-tag>
        <div class="input-form-wrap-row" v-if="orderDetail.plateThickness">
          <div class="input-label">
            <span>导板厚度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorPlateThickness}">{{orderDetail.plateThickness}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.teethModelDeviation">
          <div class="input-label">
            <span>牙齿/模型偏移：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorTeethModelDeviation}">{{orderDetail.teethModelDeviation}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.servCataId == '1010698' || orderDetail.servCataId == '1010699'">
          <div class="input-label">
            <span>倒凹保留量：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorRecessedRetentionAmount}">{{orderDetail.recessedRetentionAmount}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.guideRingCompensatio">
          <div class="input-label">
            <span>从导环的补偿：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorGuideRingCompensatio}">{{orderDetail.guideRingCompensatio}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.adhesiveGap">
          <div class="input-label">
            <span>黏着剂间隙：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorAdhesiveGap}">{{orderDetail.adhesiveGap}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-two" v-if="orderDetail.adhesiveExtraGap">
          <div class="input-label">
            <span>额外黏着剂间隙：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorAdhesiveExtraGap}">{{orderDetail.adhesiveExtraGap}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.minThick&&orderDetail.designSoftware == '00'">
          <div class="input-label">
            <span>最小厚度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorMinThick}">{{orderDetail.minThick}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.wallHeight">
          <div class="input-label">
            <span>壁高度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorWallHeight}">{{orderDetail.wallHeight}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-distance" v-if="orderDetail.edgeLineDistance">
          <div class="input-label">
            <span>到边缘线的距离：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorEdgeLineDistance}">{{orderDetail.edgeLineDistance}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.smoothDistance">
          <div class="input-label">
            <span>平滑距离：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorSmoothDistance}">{{orderDetail.smoothDistance}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.burRadius">
          <div class="input-label">
            <span>车针半径：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorBurRadius}">{{orderDetail.burRadius}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.burGapOffset">
          <div class="input-label">
            <span>车针补偿间距：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorBurGapOffset}">{{orderDetail.burGapOffset}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.edgeLineOffset">
          <div class="input-label">
            <span>边缘线补偿：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorEdgeLineOffset}">{{orderDetail.edgeLineOffset}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.stretchOffset">
          <div class="input-label">
            <span>延伸补偿：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorStretchOffset}">{{orderDetail.stretchOffset}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.angleOffset">
          <div class="input-label">
            <span>补偿角度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorAngleOffset}">{{orderDetail.angleOffset}} 度</span>
          </div>
        </div>
        <div class="input-form-wrap-one" v-if="['2010210','2010220'].includes(orderDetail.servCataId)&&orderDetail.designSoftware == '00'">
          <div class="input-label">
            <span>舌侧边补偿(宽度)：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorTongueSideOffset}">{{orderDetail.isTongueSide=='0'?'无':'有'}}</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.isTongueSide&&orderDetail.isTongueSide=='1'&&orderDetail.sideOffset=='0'">
          <div class="input-label">
            <span>舌侧边：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorTongueSideOffset}">{{orderDetail.tongueSideOffset}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.isTongueSide&&orderDetail.isTongueSide=='1'&&orderDetail.sideOffset=='1'">
          <div class="input-label">
            <span>360度边：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorCircleSideOffset}">{{orderDetail.circleSideOffset}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" style="height: 32px;" v-if="orderDetail.polymerization">
          <div class="input-label">
            <span>聚合度	：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorPolymerization}">{{orderDetail.polymerization}} 度</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.baseHeight">
          <div class="input-label">
            <span>基台不低于	：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorBaseHeight}">{{orderDetail.baseHeight}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.shoulderWidth">
          <div class="input-label">
            <span>肩台宽度	：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorShoulderWidth}">{{orderDetail.shoulderWidth}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.shoulderAngle">
          <div class="input-label">
            <span>肩台角度	：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorShoulderAngle}">{{orderDetail.shoulderAngle}} 度</span>
          </div>
        </div>
        <div class="input-form-wrap-one" v-if="abutment && orderDetail.supragingival">
          <div class="input-label">
            <span>肩台与牙龈位置：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorGingiva}">{{orderDetail.gingiva=='01'?'龈下':(orderDetail.gingiva=='02'?'齐龈':'龈上')}} </span>
            <span :style="{color: colorSupragingival}">{{orderDetail.gingiva=='02'?'':orderDetail.supragingival+'mm'}}</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.occlusalClearance">
          <div class="input-label">
            <span>咬合间隙：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorocclusalClearance}">{{orderDetail.occlusalClearance}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.adjacencyGap">
          <div class="input-label">
            <span>邻接间隙：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorAdjacencyGap}">{{orderDetail.adjacencyGap}} mm</span>
          </div>
        </div>
        <!-- add -->
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>内冠厚度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorInnerCrownThickness}">{{orderDetail.innerCrownThickness}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>咬合空间：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorOcclusionSpace}">{{orderDetail.occlusionSpace}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>粘接剂厚度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorAdhesiveThickness}">{{orderDetail.adhesiveThickness}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>牙龈厚度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorGingivalThickness}">{{orderDetail.gingivalThickness}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>到邻牙距离：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorDistanceAdjacentTooth}">{{orderDetail.distanceAdjacentTooth}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>边缘线下移：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorMarginLineShift}">{{orderDetail.marginLineShift}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>粘接间隙：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorCementGap}">{{orderDetail.cementGap}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>从边缘线：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorFromMarginLine}">{{orderDetail.fromMarginLine}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>边缘水平宽度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorEdgeHorizontalWidth}">{{orderDetail.edgeHorizontalWidth}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>边缘倾斜宽度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorEdgeTiltWidth}">{{orderDetail.edgeTiltWidth}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>边缘倾斜角度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorEdgeInclinationAngle}">{{orderDetail.edgeInclinationAngle}} 度</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>边缘垂直高度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorEdgeVerticalHeight}">{{orderDetail.edgeVerticalHeight}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>轴向额外间隙：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorAxialExtraClearance}">{{orderDetail.axialExtraClearance}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>径向额外间隙：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorRadialExtraClearance}">{{orderDetail.radialExtraClearance}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>禁止填除边缘：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorProhibitedFillingMargin}">{{orderDetail.prohibitedFillingMargin}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>边缘粘接剂宽度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorMarginCementWidth}">{{orderDetail.marginCementWidth}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>顶部粘接剂宽度：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorTopAdhesiveWidth}">{{orderDetail.topAdhesiveWidth}} mm</span>
          </div>
        </div>
        <div class="input-form-wrap-row" v-if="orderDetail.designSoftware=='10'">
          <div class="input-label">
            <span>连接杆横截面积：</span>
          </div>
          <div class="input-value">
            <span :style="{color: colorCrossSectionalAreaConnector}">{{orderDetail.crossSectionalAreaConnector}} mm²</span>
          </div>
        </div>
      </div>
      <div class="order-input-wrap" v-if="orderDetail.impSystem&&common.serv.get(orderDetail.servCataId).isImpSystem !== '1'">
        <base-tag :label="orderDetail.servCataId=='1010120'&&orderDetail.withServCataId!=''?'基台设计需求':'种植体信息'"></base-tag>
          <div class="input-form-wrap-two">
            <div class="input-label">
              <span>植体系统 ：</span>
            </div>
            <div class="input-value">
              {{orderDetail.impSystem}}
            </div>
          </div>

          <div class="input-form-wrap-two">
            <div class="input-label">
              <span>植体型号 ：</span>
            </div>
            <div class="input-value" v-if="orderDetail.impSystem != '99'">
              {{orderDetail.impModel}}
            </div>
            <div class="input-value" v-else>
              <span>{{orderDetail.impExtra}}</span>
            </div>
          </div>
          <div class="input-form-wrap-row">
            <div class="input-label">
              <span>扫描杆：</span>
            </div>
            <div class="input-value">
              {{orderDetail.scanningRod == '01' ? '口内扫描杆':'口外扫描杆'}}
            </div>
          </div>
          <div class="input-form-wrap-row"
            v-if="orderDetail.scanningRodSupplier">
            <div class="input-label">
              <span>扫描杆供应商：</span>
            </div>
            <div class="input-value">
              {{orderDetail.scanningRodSupplier}}
            </div>
          </div>
      </div>
      <!-- 器械规格 -->
      <div class="order-input-wrap" v-if="orderDetail.surgicalBoxSupplier">

        <base-tag label="器械规格"></base-tag>
        <div class="input-form-wrap-fore" :style="orderDetail.surgicalBoxSupplier.length<=7?'width:25%;':''">
          <div class="input-label">
            <span>手术器械盒供应商 ：</span>
          </div>
          <div class="input-value">
            {{orderDetail.surgicalBoxSupplier}}
          </div>
        </div>

        <div class="input-form-wrap-fore" :style="orderDetail.surgicalBoxSupplier.length<=7?'width:25%;':''">
          <div class="input-label">
            <span>导环规格和型号 ：</span>
          </div>
          <div class="input-value">
            {{orderDetail.plantModel}}
          </div>
        </div>

      </div>
      <!-- 备注信息 -->
      <div class="order-input-wrap">
        <base-tag label="备注信息"></base-tag>
        <div class="input-textarea">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 20 }" disabled readonly v-model="orderDetail.orderRemark" />
        </div>
      </div>
    </div>
    <div v-if="orderDetail.servCataId=='3010130'">
      <OrthoOrderDetail :orderDetail="orderDetail" />
    </div>
  </div>
</template>

<script>
  import BaseTag from '/components/BaseTag';
  import DictTag from '/components/DictTag';
  import YTooth from '/components/YTooth';
  import OrthoOrderDetail from './orthodonticsOrder/orthodonticsOrderDetail';
  import {
    mapState
  } from 'vuex'
import { parseMoney } from '../../utils/utils'
  export default {
    data(){
    	return{
			colorAdhesiveGap: '',   //黏着剂间隙
			colorAdhesiveExtraGap: '', //额外黏着剂间隙
			colorMinThick: '',         //最小厚度
			colorWallHeight: '',       //壁高度
			colorEdgeLineDistance: '',   //到边缘线的距离
			colorSmoothDistance: '',   //平滑距离
			colorBurRadius: '',       //车针半径
			colorBurGapOffset: '',     //车针补偿间距
			colorEdgeLineOffset: '',   //边缘线补偿
			colorStretchOffset: '',    //延伸补偿
			colorAngleOffset: '',      //补偿角度
			colorTongueSideOffset: '', //舌侧边
			colorCircleSideOffset: '', //360度边
			colorPlateThickness:'',//导板厚度
			colorTeethModelDeviation:'',//牙齿/模型偏移
			colorRecessedRetentionAmount:'',//倒凹保留量
			colorGuideRingCompensatio:'',//从导环的补偿
			colorPolymerization:'',//聚合度
			colorBaseHeight:'',//基台高度
			colorShoulderWidth:'',//肩台宽度
			colorShoulderAngle:'',//肩台角度
			colorGingiva:'',//牙龈位置
			colorSupragingival:'',//龈上参数
      colorocclusalClearance:'',//咬合间隙
      colorAdjacencyGap:'',//邻接间隙
      // exo设计参数
      colorInnerCrownThickness:'',
      colorOcclusionSpace:'',
      colorAdhesiveThickness:'',
      colorEdgeHorizontalWidth:'',
      colorEdgeTiltWidth:'',
      colorEdgeInclinationAngle:'',
      colorEdgeVerticalHeight:'',
      colorTopAdhesiveWidth:'',
      colorAxialExtraClearance:'',
      colorRadialExtraClearance:'',
      colorCrossSectionalAreaConnector:'',
      colorProhibitedFillingMargin:'',
      colorGingivalThickness:'',
      colorDistanceAdjacentTooth:'',
      colorMarginLineShift:'',
      colorCementGap:'',
      colorFromMarginLine:'',
      colorMarginCementWidth:'',

			CAMName:'', //CAM名称
			impSystem: '',/** 植体系统 */
			impModel: '', /** 植体型号 */
			idProperty: 'implId',
			fixed: false ,//固定订单
			digitalize : true ,//数字化订单显示设计信息
			abutment:false,//基台
      fund: 0 ,
      basePrice: 0 ,
      quantity: 0 ,
      extraUnitPrice: 0 ,
      orderCount:0,
      designCost: 0,
      isBridge:false
    	}
    },
    props: {
      orderDetail: {
        type: Object,
        default: null
      },
      implList: {
        type: Array,
      }
    },
    computed: {
      ...mapState(['common', 'user']),
      bridgeFlag(){
        let id = this.orderDetail.servCataId;
        if(['1010698','1010699','1010700','1010310','1010320','1010510','2010320','2010420'].includes(id)){
          return false;
        }
        let single = this.orderDetail.posSingleList;
        let bridge = this.orderDetail.posBridgeList;
        if(single&&bridge){
          return false;
        }else if(!single){
          this.isBridge = true;
        }else if(!bridge){
          this.isBridge = false;
        }
        if(this.orderDetail.posSingleList||this.orderDetail.posBridgeList){
          return true;
        }
        return false;
      }
    },
    methods: {
      // 判断属性是否一致，设置颜色
      separate(item,detail){
        if((!['2010210','1010210','1010220'].includes(detail.servCataId)||this.orderDetail.withServCataId=='1010120')&&item.deviceName!='exocad'){
          this.CAMName = detail.deviceType == '99'?detail.otherDeviceType:item.deviceName;
        }
        this.colorAdhesiveGap = detail.adhesiveGap == item.adhesiveGap ? "#666": '#2979ff'
        this.colorAdhesiveExtraGap = detail.adhesiveExtraGap == item.adhesiveExtraGap ? "#666": '#2979ff'
        this.colorMinThick = detail.minThick == item.minThick ? "#666": '#2979ff'
        this.colorWallHeight = detail.wallHeight == item.wallHeight ? "#666": '#2979ff'
        this.colorEdgeLineDistance = detail.edgeLineDistance == item.edgeLineDistance ? "#666": '#2979ff'
        this.colorSmoothDistance = detail.smoothDistance == item.smoothDistance ? "#666": '#2979ff'
        this.colorBurRadius = detail.burRadius ==item.burRadius ? "#666": '#2979ff'
        this.colorBurGapOffset = detail.burGapOffset == item.burGapOffset ? "#666": '#2979ff'
        this.colorEdgeLineOffset = detail.edgeLineOffset == item.edgeLineOffset ? "#666": '#2979ff'
        this.colorStretchOffset = detail.stretchOffset == item.stretchOffset ? "#666": '#2979ff'
        this.colorAngleOffset = detail.angleOffset == item.angleOffset ? "#666": '#2979ff'
        this.colorCircleSideOffset = detail.circleSideOffset == item.circleSideOffset ? "#666": '#2979ff'
        this.colorTongueSideOffset = detail.tongueSideOffset == 1 ? "#666": '#2979ff'
        this.colorPlateThickness = detail.plateThickness == item.plateThickness ? "#666": '#2979ff'
        this.colorTeethModelDeviation = detail.teethModelDeviation == item.teethModelDeviation ? "#666": '#2979ff'
        this.colorRecessedRetentionAmount = detail.recessedRetentionAmount == item.recessedRetentionAmount ? "#666": '#2979ff'
        this.colorGuideRingCompensatio = detail.guideRingCompensatio == item.guideRingCompensatio ? "#666": '#2979ff'
        this.colorPolymerization = detail.polymerization == item.polymerization ? "#666": '#2979ff'
        this.colorBaseHeight = detail.baseHeight == item.baseHeight ? "#666": '#2979ff'
        this.colorShoulderWidth = detail.shoulderWidth == item.shoulderWidth ? "#666": '#2979ff'
        this.colorShoulderAngle = detail.shoulderAngle == item.shoulderAngle ? "#666": '#2979ff'
        this.colorGingiva =detail.gingiva == '01' ? "#666": '#2979ff'
        this.colorSupragingival = detail.supragingival == 1 ? "#666": '#2979ff'
        this.colorocclusalClearance = detail.occlusalClearance == item.occlusalClearance ? "#666": '#2979ff'
        this.colorAdjacencyGap = detail.adjacencyGap == item.adjacencyGap ? "#666": '#2979ff'

        this.colorInnerCrownThickness = detail.innerCrownThickness == item.innerCrownThickness?"#666":"#2979ff"
        this.colorOcclusionSpace = detail.occlusionSpace == item.occlusionSpace?"#666":"#2979ff"
        this.colorAdhesiveThickness = detail.adhesiveThickness == item.adhesiveThickness?"#666":"#2979ff"
        this.colorEdgeHorizontalWidth = detail.edgeHorizontalWidth == item.edgeHorizontalWidth?"#666":"#2979ff"
        this.colorEdgeTiltWidth = detail.edgeTiltWidth == item.edgeTiltWidth?"#666":"#2979ff"
        this.colorEdgeInclinationAngle = detail.edgeInclinationAngle == item.edgeInclinationAngle?"#666":"#2979ff"
        this.colorEdgeVerticalHeight = detail.edgeVerticalHeight == item.edgeVerticalHeight?"#666":"#2979ff"
        this.colorTopAdhesiveWidth = detail.topAdhesiveWidth == item.topAdhesiveWidth?"#666":"#2979ff"
        this.colorAxialExtraClearance = detail.axialExtraClearance == item.axialExtraClearance?"#666":"#2979ff"
        this.colorRadialExtraClearance = detail.radialExtraClearance == item.radialExtraClearance?"#666":"#2979ff"
        this.colorCrossSectionalAreaConnector = detail.crossSectionalAreaConnector == item.crossSectionalAreaConnector?"#666":"#2979ff"
        this.colorProhibitedFillingMargin = detail.prohibitedFillingMargin == item.prohibitedFillingMargin?"#666":"#2979ff"
        this.colorGingivalThickness = detail.gingivalThickness == item.gingivalThickness?"#666":"#2979ff"
        this.colorDistanceAdjacentTooth = detail.distanceAdjacentTooth == item.distanceAdjacentTooth?"#666":"#2979ff"
        this.colorMarginLineShift = detail.marginLineShift == item.marginLineShift?"#666":"#2979ff"
        this.colorCementGap = detail.cementGap == item.cementGap?"#666":"#2979ff"
        this.colorFromMarginLine = detail.fromMarginLine == item.fromMarginLine?"#666":"#2979ff"
        this.colorMarginCementWidth = detail.marginCementWidth == item.marginCementWidth?"#666":"#2979ff"
      },
      // 非叠加适应症判断设备属性
      loopIf(data,detail){
        data.forEach((val,i)=>{
          val.children.forEach((item,x)=>{
            if(item.servCode == detail.servCataId && (item.deviceType == detail.deviceType || detail.deviceType == '99')){
              if((detail.servCataId == '1010120'||detail.servCataId == '2010120'||
                 detail.servCataId == '2010220'||detail.servCataId == '2010320'||
                 detail.servCataId == '2010420')&&detail.deviceType=='99'){
                if(item.deviceName == '威兰德'&&item.servCode=='1010120'&&detail.servCataId=='1010120'&&(detail.deviceType=='04'||detail.deviceType=='99')){
                  this.separate(item,detail)
                }else if(item.deviceName == '柯乐德 cradle'&&item.servCode!='1010120'&&detail.servCataId!='1010120'){
                  this.separate(item,detail)
                }
              }else{
                this.separate(item,detail)
              }
              }else if(item.deviceName == ''&&i == 0){
              // 基台设计(无选择设备的参数)
              if((detail.servCataId == '1010210'|| detail.servCataId == '1010220') &&(item.servCode=='1010210'||item.servCode=='1010220')){
                this.colorocclusalClearance = detail.occlusalClearance == item.occlusalClearance ? '#666': '#2979ff'
                this.colorAdjacencyGap = detail.adjacencyGap == item.adjacencyGap ? '#666': '#2979ff'
                this.colorPolymerization = detail.polymerization == item.polymerization ? "#666": '#2979ff'
                this.colorBaseHeight = detail.baseHeight == item.baseHeight ? "#666": '#2979ff'
                this.colorShoulderWidth = detail.shoulderWidth == item.shoulderWidth ? "#666": '#2979ff'
                this.colorShoulderAngle = detail.shoulderAngle == item.shoulderAngle ? "#666": '#2979ff'
                this.colorGingiva = detail.gingiva == '01' ? "#666": '#2979ff'
                this.colorSupragingival = detail.supragingival == item.supragingival ? '#666': '#2979ff'
              }else if((detail.servCataId == '1010310'|| detail.servCataId == '1010320') &&(item.servCode=='1010310'||item.servCode=='1010320')){
                this.colorocclusalClearance = detail.occlusalClearance == item.occlusalClearance ? '#666': '#2979ff'
                this.colorAdjacencyGap = detail.adjacencyGap == item.adjacencyGap ? '#666': '#2979ff'
              }
            }else if(detail.servCataId == item.servCode&&detail.servCataId == '2010210'){
              // 烤瓷冠(内冠金属)无选择设备
              this.separate(item,detail)
            }
          })
          // 单独设置匹配exo参数,放在函数最后==>要给camName找对应deviceName
          if(this.orderDetail.designSoftware=='10'){
            this.separate(data[2],detail);
          }
        })
      },
      // 获取参数字典详情
    	getParamInfo(){
        this.$api.get({
        url:'/common/deviceParam',
        isToken: false
        }).then(res=>{
          if(this.orderDetail.withServCataId){
            this.withIdInfo(res.data)
          }else{
            this.loopIf(res.data,this.orderDetail)
          }
        })
    	},
      isShow(){
        let id = this.orderDetail.servCataId;
        if(id=='3010130'||!id){
          return false;
        }
        // 判断设计信息显示
        if(id == '1010120' ||id == '2010120' ||
           id == '2010210' ||id == '2010220' ||
           id == '2010320' ||id == '2010420'){
        	this.fixed = true
        }
        // 参数信息
        if(id == '1010698' ||id == '1010699' ||id == '1010700' || id == '1010510'||id == '1010410'||
           ((id == '1010310'||id == '1010320'||((id == '1010210'||
           id == '1010220')&&this.orderDetail.withServCataId == ''))&&
           this.orderDetail.desLevel == '99')){
        	this.digitalize = false
        }else{
          this.digitalize = true
        }
        if((id == '1010210' ||id == '1010220' ||
            id == '1010310' ||id == '1010320' ||
            this.orderDetail.withServCataId.includes('1010210')||
            this.orderDetail.withServCataId.includes('1010220'))&&
            this.orderDetail.gingiva != 'undefined' ){
        	this.abutment = true
        }
        if(id == '1010120' ||id == '2010120'){
          this.orderDetail.isTongueSideShow = '1'
        }
      },
      // 设计师未接单隐藏信息
      hideInfo(){
        let status = this.orderDetail.orderStatus
        if((status == '10' && this.user.userType == '20')||status == '99'||
        status == '90'||status == '91'||status == '92'||status == '98'){
          var str1 = '';
          var str2 = '';
          var str3 = '';
          var str4 = '';
          for (var i = 0; i < this.orderDetail.demContact.length-2; i++) {
            str1 +='*'
          }
          for (var i = 0; i < this.orderDetail.demPatient.length-2; i++) {
            str2 +='*'
          }
          str3 =  this.orderDetail.demContact.slice(0,1)+str1+this.orderDetail.demContact.slice(-1)
          str4 =  this.orderDetail.demPatient.slice(0,1)+str2+this.orderDetail.demPatient.slice(-1)
          this.orderDetail.demPhone = this.orderDetail.demPhone.slice(0,3)+'****'+this.orderDetail.demPhone.slice(-4)
          this.orderDetail.demContact = this.orderDetail.demContact.length == 2? this.orderDetail.demContact.slice(0,1)+'*':str3;
          this.orderDetail.demPatient = this.orderDetail.demPatient.length == 2? this.orderDetail.demPatient.slice(0,1)+'*':str4;
        }
      },
      // 解析叠加适应症id计算数量及单价
      toothNum(arr1,arr2,arr3){
        var order = this.orderDetail
        var arr = order.withServCataId?order.withServCataId.split(','):[];
        arr.forEach((item,i)=>{
          if(['1010210','1010220','1010120'].includes(order.servCataId)&&order.withServCataId!==''){
            if(item == '1010210'){
              this.fund = arr2.length
              this.basePrice = this.changePrice(this.orderDetail.desLevel,item)
            }else if(item == '1010220'){
              this.fund = arr3.length
              this.basePrice = this.changePrice(this.orderDetail.desLevel,item)
            }else if(item == '1010120'){
              if(order.servCataId == '1010210'||order.servCataId == '1010220'){
                if(this.orderDetail.posBridgeList==undefined||this.orderDetail.posBridgeList[0] == ''){
                  this.orderDetail.posBridgeList= []
                  this.orderDetail.posBridgeList.length = 0
                }
                this.quantity = arr1.length
              }
              this.extraUnitPrice = this.changePrice(this.orderDetail.desLevel,item)
            }
          }
          if(order.servCataId == '1010120'&&order.withServCataId){
            this.fund = arr3.length + arr2.length
            this.basePrice = this.changePrice(this.orderDetail.desLevel,item)
          }
        })
        this.orderCount = this.orderDetail.orderCount - this.fund - this.quantity
      },
      // 设计师等级和订单id获取叠加适应症的单价
      changePrice(level,id){
        if (level == '01') {
          return parseFloat(this.common.serv.get(id).ftyBpricePri).toFixed(2)
        } else if (level == '02') {
          return parseFloat(this.common.serv.get(id).ftyBpriceMid).toFixed(2)
        } else if (level == '03') {
          return parseFloat(this.common.serv.get(id).ftyBpriceSen).toFixed(2)
        } else if (level == '99') {
          return parseFloat(this.common.serv.get(id).clnBprice).toFixed(2)
        }else{
          return null;
        }
      },
      // 获取叠加适应症参数字典
      withIdInfo(data){
        var arr1 = []
        var arr2 = []
        var arr3 = []
        var temp1 = this.orderDetail
        var idList = temp1.withServCataId.split(',')
        if(temp1.withServCataId){
          let id = temp1.servCataId
          let mergedObj = []
          if((id=='1010210'||id=='1010220')&&temp1.withServCataId!=''){
            // 单独区分匹配基台复合适应症的参数
            if(temp1.withServCataId == '1010120'||temp1.withServCataId.includes('1010120')){
              data[0].children.forEach(val=>{
                //找到复合适应症是上部冠对应的cam设备及参数
                if(val.servName == '种植上部修复冠' && val.deviceType == temp1.deviceType){
                  mergedObj = this.mergeNonZeroProps(val,data[0].children[14])
                }
              })
              this.separate(mergedObj,this.orderDetail)
            }else if((id == '1010210'||id=='1010220')&&(temp1.withServCataId.includes('1010210')||temp1.withServCataId.includes('1010220'))){
              // 主服务类是基台、复合适应症也是基台
              this.separate(data[0].children[14],this.orderDetail)
            }
          }else{
            data.forEach((val,i)=>{
              val.children.forEach((item,x)=>{
                // 主服务类的设备参数
                if(temp1.servCataId == item.servCode&&temp1.deviceType == item.deviceType){
                  arr1 = item
                }else if((temp1.servCataId=='1010210'&&item.servCode=='1010210')||(temp1.servCataId=='1010220'&&item.servCode=='1010220')){
                  arr1 = item
                }else if(temp1.servCataId == '1010120'&&temp1.deviceType == '99'&&item.deviceName == '威兰德'&&item.servCode=='1010120'){
                  arr1 = item
                }
                // 额外服务类的设备参数
                idList.forEach((a,b)=>{
                  if(a==item.servCode&&temp1.deviceType == item.deviceType){
                    arr2 = item
                  }else if((a=='1010210'&&item.servCode=='1010210')||(a=='1010220'&&item.servCode=='1010220')){
                    arr3 = item
                  }
                })
              })
            })
            let mergedObj = this.mergeNonZeroProps(arr1, arr2, arr3);
            this.separate(mergedObj,this.orderDetail)
          }
        }
      },
      // 合并对象非0属性
      mergeNonZeroProps(...objs) {
        return objs.reduce((acc, obj) => {
          Object.entries(obj).forEach(([key, value]) => {
            if (value !== 0 && ![null, undefined, '', false].includes(value)) {
              acc[key] = value;
            }
          });
          return acc;
        }, {});
      },
    },
	created() {
    this.isShow();
		this.getParamInfo();
    this.hideInfo();
	},
    mounted(){
      if(['','0'].includes(this.orderDetail.withServCataId)){
        this.orderCount = this.orderDetail.orderCount
      }
    },
    components: {
      YTooth,
      BaseTag,
      DictTag,
      OrthoOrderDetail
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/mixin";
  .order-input-wrap {
    width: 100%;
    position: relative;
  }

.input-form-wrap,.input-form-wrap-row,
.input-form-wrap-two,.input-form-wrap-one,
.input-form-wrap-three,.input-form-wrap-fore,
.input-form-wrap-distance,.input-form-wrap-system{
    float: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

  // 输入框
  .input-form-wrap {
    width: 33%;
    padding: 7px 10px;
    .input-label {
      // flex: 1;
      width: 140px;
      margin-left: 2%;
    }
    .input-label-bridge {
      // flex: 1;
      width: 145px;
      margin-left: 2%;
    }
  }

  // 四列输入框
  .input-form-wrap-row {
    width: 25%;
    padding: 7px 10px;
    .input-label {
      // flex: 1;
      width: 110px;
      margin-left: 2%;
    }
  }
  .input-form-wrap-two{
	width: 24%;
	padding: 7px 0px 7px 10px;
	font-size: 14px;
	margin-right: 11px;
	.input-label {
	  width: 112px;
	  margin-left: 2%;
	}
  }
  .input-form-wrap-three{
  width: 25%;
  padding: 7px 0px 7px 10px;
  margin-right: 11px;
  .input-label {
    width: 112px;
    margin-left: 2%;
  }
  }
  .input-form-wrap-one{
	width: 25%;
	padding: 5px 10px;
	font-size: 14px;
	.input-label {
	  width: 125px;
	  margin-left: 2%;
	}
  }
  .input-form-wrap-distance{
	width: 24%;
	margin-right: 1%;
	padding: 7px 0px 7px 8px;
	font-size: 14px;
	.input-label {
	  width: 113px;
	  margin-left: 2%;

	}
  }

  .input-form-wrap-system{
	width: 34%;
	padding: 7px 10px;
	font-size: 14px;
	.input-label {
	  width: 110px;
	  margin-left: 2%;
	}
  }

  .input-form-wrap-fore{
  	width: 30%;
  	padding: 7px 10px;
  	font-size: 14px;
  	.input-label {
  	  width: 130px;
  	  margin-left: 2%;
  	}
  }
  .input-value {
   flex: 1;
   border: 1px solid #DCDFE6;
   border-radius: 4px;
   box-sizing: border-box;
   padding: 2px 10px;
   background-color: #ECECEC;
   width: 260px;
  }
  .input-textarea {
    padding: 5px 10px;
  }

  .el-textarea.is-disabled .el-textarea__inner {
      border-color: #DCDFE6;
      color: #606266;
      cursor: not-allowed;
      font-size: 14px;
      background-color: #ECECEC;
  }
.param-info::after{
	content: '(黑色为默认参数，仅供参考)';
	font-size: 12px;
	position: absolute;
	top: 18px;
	left: 80px;
}
.radio-wrap{
  position: absolute;
  top: 37%;
  left: 10%;
}
.input-form-wrap,.input-form-wrap-row,
  .input-form-wrap-two,.input-form-wrap-one,
  .input-form-wrap-three,.input-form-wrap-fore,
  .input-form-wrap-distance,.input-form-wrap-system{
      height: 32px;
  }
</style>



// WEBPACK FOOTER //
// detailOrder.vue?586e9393